import { render, staticRenderFns } from "./ReservedAddressesCard.vue?vue&type=template&id=11774936&scoped=true"
import script from "./ReservedAddressesCard.vue?vue&type=script&lang=ts"
export * from "./ReservedAddressesCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11774936",
  null
  
)

export default component.exports